import { render, staticRenderFns } from "./UProgressBar.vue?vue&type=template&id=3c2d60e4"
import script from "./UProgressBar.vue?vue&type=script&lang=js"
export * from "./UProgressBar.vue?vue&type=script&lang=js"
import style0 from "./UProgressBar.vue?vue&type=style&index=0&id=3c2d60e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports